<template lang="html">
	<wizard-screen
		panelClass="omapi-panel__4"
		:completed="4"
		:total="5"
		:navPrev="false"
		:navNext="false"
	>

		<h2>Connect Your Site with OptinMonster</h2>
		<core-alerts id="om-connect-errors" v-if="error" :alerts="alerts"></core-alerts>

		<div class="omapi-happy-text">
			OptinMonster is a powerful conversion toolkit that works on all website platforms.
			Create an account to connect your website with OptinMonster.
		</div>

		<div>
			<core-loading v-if="isLoading">
				<strong>Please wait...</strong>
			</core-loading>
			<wizard-next-link
				v-else
				type="button"
				@click.prevent="openCheckoutWindow"
				class="omapi-button__large"
				text="Create a Free Account"
				ref="toFocus"
			/>
		</div>

		<div v-if="showProUpsells" class="omapi-box__gray">
			<h3>OptinMonster comes with a forever free license for WordPress users 😀</h3>
			<div>If you choose to upgrade to Pro, you will receive a <b>35% discount</b> - automatically applied at checkout.
			</div>
		</div>
	</wizard-screen>
</template>

<script lang="js">
import { getAppData } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	mounted () {
		if (this.userId) {
			return this.skip()
		}

		this.$store.commit('clearAlerts')
		window.addEventListener('message', this.listenMessage)

		const $ref = this.$get('$refs.toFocus.$refs.el')
		if ($ref) {
			// Use instead of $nextTick, or the button gets auto-clicked, ¯\_(ツ)_/¯
			setTimeout(() => {
				$ref.focus()
			}, 50)
		}
	},

	beforeDestroy : function () {
		window.removeEventListener('message', this.listenMessage)
	},

	computed : {
		...mapState([ 'error', 'alerts' ]),
		...mapGetters([ 'userEmail', 'userFirstName', 'userLastName', 'userId', 'showProUpsells' ]),
		...mapGetters('wp', [ 'isWooActive', 'isWooConnected' ]),
		isLoading () {
			return this.$store.getters.isLoading([ 'connect', 'wizard' ])
		},
		isDisabled () {
			return this.isLoading || !this.$store.state.apiKey
		},
	},
	methods : {
		...mapActions([ 'saveApiKey' ]),
		listenMessage (evt) {
			const { origin, data } = evt
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return
			}

			if (!data || 'string' !== typeof data) {
				return
			}

			try {
				// Get passed status.
				const data = JSON.parse(evt.data)

				if (!data.omWizard) {
					throw new Error('no')
				}

				// Do action based on status.
				switch (data.status) {
				case 'loaded':
					this.onCheckoutLoaded(data)
					break
				case 'registered':
					this.onCheckoutRegistered(data.apiKey)
					break
				case 'complete':
					window.location.reload()
					break
				default:
				}
			} catch (e) {

			}
		},
		openCheckoutWindow () {
			let url = this.$urls.app('checkout/wp-plugin/')
			const partnerUrl = getAppData('partnerUrl')
			if (partnerUrl) {
				const urlObj = new URL(partnerUrl)
				urlObj.searchParams.set('urllink', url)
				url = urlObj.toString()
			}

			this.childWindow = window.open(
				url,
				'_blank',
				'width=700,height=700,left=200,top=100'
			)
		},
		onCheckoutLoaded (data) {
			const payload = {
				omWizard  : true,
				status    : 'loaded',
				origin    : window.location.protocol + '//' + window.location.host,
				siteName  : getAppData('blogname'),
				partnerId : getAppData('partnerId'),
				user      : {
					email     : this.userEmail,
					firstName : this.userFirstName,
					lastName  : this.userLastName,
				},
				onboarding : {
					via                      : 'wordpress',
					woocommerce_active       : this.isWooActive,
					woocommerce_connected    : this.isWooConnected,
					usage                    : this.onboardingUsage,
					usage_other_text         : this.onboardingUsageOtherText,
					email_list               : this.onboardingEmailList,
					email_service            : this.onboardingEmailService,
					email_service_other_text : this.onboardingEmailServiceOtherText,
					goal                     : this.onboardingGoal,
					extra_features           : this.extraFeatures,
				},
			}

			this.childWindow.postMessage(JSON.stringify(payload), this.$urls.app())
		},
		onCheckoutRegistered (apiKey) {
			const done = () => {
				this.$store.commit('loading', 'wizard')

				window.location.reload()
			}
			this.saveApiKey(apiKey)
				.then(done)
				// eslint-disable-next-line handle-callback-err
				.catch((error) => {
					// TODO Handle failures here.
					// What happens with user, etc? How can they proceed?
					done()
				})
		},
	},
}
</script>

<style scoped lang="scss">
	.omapi-screen .omapi-panel__4 {
		.omapi-wizard-forward {
			border-radius: 3px;
			font-size: 16px;
			margin: 0 0 40px;
			padding: 16px 60px;
		}
		.om-circle-loading {
			margin: 0 0 20px;
		}

		.omapi-button__large {
			margin-bottom: 33px !important;
		}
	}
</style>
